<template>
	<transition :name="transition">
		<div class="v5-toast" :class="[position, clickPass? 'click-pass':'']" v-show="show">
			<div class="v5-toast-content" v-if="text" v-html="text">
			</div>
			<div class="v5-toast-content" v-else>
				<slot></slot>
			</div>
		</div>
	</transition>
</template>
<script>
	export default {
		name: 'v5-toast',
		props: {
			value: {
				type: Boolean,
				default: false
			},
			text: {
				type: String
			},
			time: {
				type: Number,
				default: 2000
			},
			position: {
				type: String,
				default: 'middle'
			},
			clickPass: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			transition() {
				if (this.position === 'top') {
					return 'v5-fade-from-top';
				}
				if (this.position === 'bottom') {
					return 'v5-fade-from-bottom';
				}

				return 'v5-fade';
			}
		},
		watch: {
			value(val) {
				this.show = val;
			},
			show(val) {
				this.$emit('input', val);
				if (val) {
					clearTimeout(this.timeout);
					this.timeout = setTimeout(() => {
						this.show = false;
					}, this.time);
				}
			}
		},
		data() {
			return {
				show: this.value
			};
		}
	};

</script>
<style lang="scss">
	@import './style.scss';

</style>
